import Major from './questions/0-Major';
import Field from './questions/0-Major-Field';
import City from './questions/1-City';
import University from './questions/1-City-University';
import ExpectedDegree from './questions/2-ExpectedDegree';
import Studies from './questions/3-Studies';
import PreviousEducation from './questions/4-PreviousEducation';
import SignUp from './questions/5-SignUp';
import ConfirmEmail from './questions/6-ConfirmEmail';

import theme from '$/assets/theme';

const stepConfig = {
  major: {
    Component: Major,
    progressBarValue: 0,
    background: null,
  },
  field: {
    Component: Field,
    progressBarValue: 0,
    background: null,
  },
  city: {
    Component: City,
    progressBarValue: 20,
    background: null,
  },
  university: {
    Component: University,
    progressBarValue: 20,
    background: null,
  },
  expectedDegree: {
    Component: ExpectedDegree,
    progressBarValue: 40,
    background: null,
  },
  studies: {
    Component: Studies,
    progressBarValue: 60,
    background: null,
  },
  previousEducation: {
    Component: PreviousEducation,
    progressBarValue: 80,
    background: null,
  },
  signUp: {
    Component: SignUp,
    progressBarValue: 95,
    background: theme.colors.mustard10,
  },
  confirmEmail: {
    Component: ConfirmEmail,
    progressBarValue: 100,
    background: theme.colors.brandGreen10,
  },
};

export default stepConfig;
